import { NotifyHelper } from "../../../helpers/toast";
import { eDmChuyenNganhActionsObj } from "../../action-types/category/IDmChuyenNganhActions";
import { generateActions, generateActionForKey } from "../generateActions";

export const chuyenNganhActions = {
  ...generateActions(eDmChuyenNganhActionsObj, "CHUYEN_NGANH"),
  ...generateActionForKey(
    eDmChuyenNganhActionsObj,
    "CHUYEN_NGANH",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDmChuyenNganhActionsObj,
    "CHUYEN_NGANH",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDmChuyenNganhActionsObj,
    "CHUYEN_NGANH",
    "SAVE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmChuyenNganhActionsObj,
    "CHUYEN_NGANH",
    "DELETE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
